export function guideStepCheck(actionLinkText, step, state) {
  const guideStepCheck = `
    <div class="w-full mt-4 mb-7 ${state ? `${state}` : ``}" data-type="stepcheckbox">    
      <label for="stepcompleated" class="toggle justify-start items-center gap-2">
        <input type="checkbox" id="stepcompleated" class="visually-hidden toggle-checkbox" required ${step.isCompleted ? `disabled checked` : ``}>
        <div class="toggle-switch"></div>
        <span class="text-blue">${actionLinkText}</span>
      </label>
    </div>
      `;

  return guideStepCheck;
}
